import React from 'react'
import { useTranslation } from 'react-i18next'
import frameshweVaultImg from '@assets/web-v3-images/frame-shweVault.png';
import imgExplorerBadge from '@assets/web-v3-images/icons/badge-explorer.png';
import imgMasterBadge from '@assets/web-v3-images/icons/badge-master.png';

const Rows = ({ titleRow }) => {
	return <p className="text-[13px] sm:text-[23px] font-bold text-[rgba(84,35,20,1)] text-center">{titleRow}</p>
}

export default function Comparison({ data }) {
	const { t } = useTranslation()

	return (
		<div
			className="relative z-2 -mt-0.5 w-full"
			style={{
				backgroundImage: `url(${frameshweVaultImg})`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "100% 100%",
				backgroundPosition: "center",
			}}
		>
			<div className="">
				<p className='absolute left-1/2 top-4 sm:top-8 -translate-x-1/2 -translate-y-1/2 text-[rgba(122,46,14,1)] 
							text-[15px] sm:text-[25px] font-bold whitespace-nowrap'>
					{data?.title}
				</p>
				<div className="w-full px-[1.5%] pt-7 sm:pt-13 mt-6 sm:mt-10 pb-1.5 sm:pb-3">
					<div className="grid grid-cols-[1fr_1fr_1fr] items-end  pt-4 pb-3 bg-[#FFDFB0]/60 rounded-tl-[20px] rounded-tr-[20px] pt-6 sm:pt-10">
						<div />
						<div className="flex flex-col items-center gap-1">
							<Rows titleRow={data?.explorer_label} />
							<img src={imgExplorerBadge} className="w-10 sm:w-20" alt="" />
						</div>

						<div className="flex flex-col items-center gap-1">
							<Rows titleRow={data?.master_label} />
							<img src={imgMasterBadge} className="w-10 sm:w-20" alt="" />
						</div>
					</div>
					{data?.benefits?.map((row, i) => (
						<div
							key={row.key}
							className={`grid grid-cols-[1fr_1fr_1fr] items-center py-2 sm:py-4 ${i % 2 === 0 ? "bg-transparent" : "bg-[#FFDFB0]/60 rounded-bl-[20px] rounded-br-[20px]"
								}`}
						>
							<div className="text-left">
								<Rows titleRow={t(row.label)} />
							</div>
							<Rows titleRow={row.explorer} />
							<Rows titleRow={row.master} />
						</div>
					))}
				</div>
			</div>
		</div>
	)
}
